export const createWishlistPromiseApi = (action) => {
    const call = (actionName, data, map = (r) => r) => new Promise((resolve, reject) => {
        action(actionName, data, {
            // `map` may throw to signal a broken response contract (e.g.
            // createWishlist with no id). Catch it so the failure rejects the
            // promise instead of throwing synchronously inside the dispatcher's
            // onSuccess — which would escape unhandled and leave the promise
            // forever pending.
            onSuccess: (result) => {
                try {
                    resolve(map(result));
                }
                catch (err) {
                    reject(err instanceof Error ? err : new Error(String(err)));
                }
            },
            onError: (err) => reject(err),
        });
    });
    return {
        getWishlists: () => call("wishlists/get", null, (result) => {
            var _a;
            const wishlists = (_a = result === null || result === void 0 ? void 0 : result.wishlists) !== null && _a !== void 0 ? _a : [];
            // Expose items under BOTH `items` and `variants` so a consumer
            // reading either key works.
            return wishlists.map((w) => { var _a; return (Object.assign(Object.assign({}, w), { variants: (_a = w.items) !== null && _a !== void 0 ? _a : [] })); });
        }),
        addItemToWishlist: (productId, variantId, wishlistId) => call("wishlist/item/add", { productId, variantId, wishlistId }),
        removeItemFromWishlist: (productId, variantId, wishlistId) => call("wishlist/item/remove", { productId, variantId, wishlistId }),
        createWishlist: (name) => call("wishlist/create", { name }, (result) => {
            const id = result === null || result === void 0 ? void 0 : result.id;
            // Don't paper over a contract break with "". The caller uses this
            // id as the target for subsequent add/remove; an empty string
            // silently corrupts those. Reject so the failure is visible.
            if (!id) {
                throw new Error("wishlist/create returned no id");
            }
            return id;
        }),
    };
};
